import React, { useState, useEffect } from 'react';
import '../../styles/components/Modal.scss';

import ProgressBar from './ProgressBar';


/**
 * Props
 * - variant    - Type de modal
 * - children   - Body de la modal
 * - alert      - Texte d'alerte à afficher au dessus du titre (est affiché avec une icone point d'exclamation)
 * - title      - Titre de la modal
 * - icon       - Icone à afficher avec le titre de la modal (ex: <i classname="icon-check" />)
 * - close      - Boolean définissant si on affiche le bouton fermer et que si on clique sur l'overlay la modal se fermera ou non
 * - onClose    - Méthode appelée lors de fermeture de la modal
 * - progress   - Valeur numérique indiquant le pourcentage de progress
 * - onConfirm  - Méthode appelée lors du clic sur Confirmer ou OK
 * - onCancel   - Méthode appelée lors du clic sur Annuler
 */
export class Modal extends React.Component {

    listeners = [];
    state = {
        display: true,
    };

    eventOpen = 'modal.open';
    eventClose = 'modal.close';

    componentDidMount() {
        setTimeout(() => { 
            this.setState({
                slideAnim: true
            });
        }, 150);
    }

    closeModal = () => {
        const { variant, close, onClose } = this.props;
        if(onClose)
            onClose();
        switch(variant) {
            case 'confirm':
            case 'confirm2':
            case 'progress':
                // Nothing to do
                break;
            default:
                if (close && this.state.display) {
                    this.setState({
                        display: false
                    });
                }
                break;
        }
    }

    renderContent() {
        const { children, variant, progress, onConfirm, onCancel, confirmBtnTxt } = this.props;
        let modalContent;
        switch(variant) {
            case 'confirm':
            case 'confirm2':
                modalContent = (
                    <React.Fragment>
                        {children && (<div className="modal__content">{ children }</div>)}
                        {variant !== 'confirm2' && (
                            <div className="modal__buttons">
                                <button className="button button--primary" onClick={onConfirm}>Confirmer</button>
                                <button className="button button--primary button--outline" onClick={onCancel}>Annuler</button>
                            </div>
                        )}
                        {variant === 'confirm2' && (
                            <div className="modal__buttons">
                                <button className="button button--warning" onClick={onCancel}>Annuler</button>
                                <button className="button button--primary button--outline" onClick={onConfirm}>Confirmer</button>
                            </div>
                        )}
                    </React.Fragment>
                );
                break;
            case 'progress':
                modalContent = (
                    <ProgressBar classname={'modal__progress'} now={progress} />
                );
                break;
                case 'alert':
                modalContent = (
                    <React.Fragment>
                        {children && (<div className="modal__content">{ children }</div>)}
                        <div className="modal__buttons">
                            <button className="button button--primary" onClick={onConfirm}>{confirmBtnTxt ? confirmBtnTxt : 'Ok'}</button>
                        </div>
                    </React.Fragment>
                );
                break;
                case 'light':
                    modalContent = (
                    <div className="modal__content">
                        <div className="modal__close" onClick={() => {window.sdk.event().emit('modalClose')}}>x</div>
                        { children }
                    </div>); 
                    break;                
            default:
                modalContent = (<div className="modal__content">{ children }</div>); 
                break;
        }

        return (
            <div className="modal__body">{ modalContent }</div>
        );
    }

    render() {

        const { variant, title, icon, close, alert, classname, onConfirm, onCancel, onClose, width, ...props } = this.props;
        const { display, slideAnim } = this.state;
        if ( !display ) {
            return null;
        }

        return (
            <div className={'modal ' + (classname || '') + (variant ? ' modal--'+variant : '') + (slideAnim ? ' modal--show' : '') + (display ? ' modal--opened' : '') + (close ? ' modal--has-close' : '')} {...props}>
                <div className="modal__backdrop" onClick={this.closeModal}></div>
                <div className="modal__inner" style={width ? {maxWidth: width+'px'} : {}}>
                    {alert && (
                        <div className="modal__alert">{ alert }</div>
                    )}
                    {close && (
                        <button className="modal__close" onClick={this.closeModal}>
                            <i className="icon-cancel"></i>
                        </button>
                    )}
                    {title && (
                        <div className="modal__header">
                            {icon && (<div className="modal__icon">{ icon }</div>)}
                            <h3 className="modal__title">{ title }</h3>
                        </div>
                    )}
                    { this.renderContent() }
                </div>
            </div>
        );
    }

}

export class ModalProgress extends React.Component {
    render() {
        const { variant, close, ...rest } = this.props;
        return (
            <Modal variant="progress" close={false} {...rest} />
        );
    }
}

export class ModalConfirm extends React.Component {
    render() {
        const { variant, close, ...rest } = this.props;
        return (
            <Modal variant="confirm" close={false} {...rest} />
        );
    }
}

export class ModalConfirm2 extends React.Component {
    render() {
        const { variant, close, ...rest } = this.props;
        return (
            <Modal variant="confirm2" close={false} {...rest} />
        );
    }
}

export class ModalAlert extends React.Component {
    render() {
        const { variant, close, ...rest } = this.props;
        return (
            <Modal variant="alert" close={false} {...rest} />
        );
    }
}


export class GlobalModal extends React.Component {

    constructor(props) {
        super(props);
        this.args = {};
        this.listeners = [];
        this.state = {
            display: false,
        };
    }

    close() {
        this.setState({
            display: false,
        }); 
    }

    componentDidMount() {
        this.listeners.push(window.sdk.event().on('modalOpen', (args) => {
            // Paramètres à envoyer
            // title, content, onConfirm, onCancel, variant
            args.children = args.content;
            delete args.content;

            this.args = args;
            
            console.log(JSON.stringify(args));
            this.setState({
                display: true
            });
        }));
        this.listeners.push(window.sdk.event().on('modalClose', () => {
            this.setState({
                display: false
            })
        }));
    }

    componentWillUnmount() {
        for (var i in this.listeners) {
            this.listeners[i]();
        }
    }

    render() {
        const { display } = this.state;
        if (!display) {
            return null;
        }
        
        this.args.classname ? this.args.classname += ' global-modal' : this.args.classname = 'global-modal';
        //this.args.classname += ' global-modal';

        switch(this.args.variant) {
            case 'confirm':
                return (<ModalConfirm {...this.args} />);
            case 'confirm2':
                return (<ModalConfirm2 {...this.args} />);
            case 'progress':
                return (<ModalProgress {...this.args} />);
            case 'alert':
                return (<ModalAlert {...this.args} />);
            default:
                return (<Modal {...this.args} />);
        }
    }
}